import { render, staticRenderFns } from "./get-text.vue?vue&type=template&id=5a8cb654&"
import script from "./get-text.vue?vue&type=script&lang=js&"
export * from "./get-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports